<template>
  <product-management state="0" />
</template>
<script>
export default {
  components: {
    productManagement: () => import('../productManagement/index.vue')
  }
}
</script>